<template id="home">
	<div class="page-home">

		<div class="left-line-1"><div class="top-edge"></div><div class="bottom-edge"></div></div>
		<div class="left-line-2"><div class="top-edge"></div><div class="bottom-edge"></div></div>
		<div class="left-line-3"><div class="top-edge"></div><div class="bottom-edge"></div></div>
		

		<div class="left">
			<div class="logo"><img src="/web-static/img/logo.png"></div>
			<div class="sub-logo"><img src="/web-static/img/sub-logo.png"></div>
			<div class="heading">
				<div class="heading-content">
					<div class="text"><span></span>&nbsp;&nbsp;&nbsp;NAVIGATION&nbsp;&nbsp;&nbsp;<span></span></div>
					<div class="bg-left"></div>
					<div class="bg-right"></div>
				</div>
			</div>
			<div class="menu">
				<div class="sub-heading">PANDORA NAVIGATION INITIALIZING</div>
				<template v-for="item in menuItems">
					<div class="divider"><div class="bg-center"></div><div class="bg-top"></div><div class="bg-bottom"></div></div>
					<div class="menu-item">
						<div class="menu-item-content">
							<router-link v-bind:to="item.link" class="box">{{item.name}}
								<span class="status"><span class="off">[ ]</span><span class="on">{{item.on}}</span></span>
							</router-link>

							<div class="diagonal-1"></div>
							<div class="diagonal-2"></div>
						</div>
						
					</div>
				</template>
				
				<div class="divider"><div class="bg-center"></div><div class="bg-top"></div><div class="bg-bottom"></div></div>
			</div>

			<div class="left-footer">
				<a target="_blank" href="http://www.skyloong.net"><img src="/web-static/img/footer-link-btn-2.png"></a>
				<a target="_blank" href="http://www.satelight.co.jp"><img src="/web-static/img/footer-link-btn-1.png"></a>
				<a target="_blank" href="http://www.project-pandora.jp" title="点击前往日版网站" class="btn-3">日</a>
				<span class="copyright-1">©2017 Shoji Kawamori, Satelight</span>
				<span class="copyright-2">/ Xiamen Skyloong Media.</span>
			</div>
		</div>


		<div class="right-line-1"><div class="top-edge"></div><div class="bottom-edge"></div></div>
		<div class="right-line-2"><div class="top-edge"></div><div class="bottom-edge"></div></div>
		<div class="right-line-3"><div class="top-edge"></div><div class="bottom-edge"></div></div>

		<div class="right">

			<div class="visuals">
				<div class="visual active" v-on:click="switchVideo(0, $event)">
					<div class="point"><div class="point-content"></div></div>
					<div class="box">VISUAL1</div>
				</div><div class="visual" v-on:click="switchVideo(1, $event)">
					<div class="point"><div class="point-content"></div></div>
					<div class="box">VISUAL2</div>
				</div><div class="visual" v-on:click="switchVideo(2, $event)">
					<div class="point"><div class="point-content"></div></div>
					<div class="box">VISUAL3</div>
				</div>
			</div>

			
			<div class="videos">
				<div class="heading">
					<div class="heading-content">
						<div class="text"><span></span>&nbsp;&nbsp;&nbsp;MOVIE&nbsp;&nbsp;&nbsp;<span></span></div>
						<div class="bg-left"></div>
						<div class="bg-right"></div>
					</div>
				</div>
				
				<div class="box">
					<div class="sub-heading">PANDORA PV</div>
					<div class="video" v-on:click="openVideoPopup">
						<div class="preview">
							<img src="/web-static/img/movie-btn.png" class="movie-btn">
							<!-- <img v-bind:src="video.preview"> -->
							<video id="video-small" v-bind:src="video.url" volume="0"></video>
						</div>
						<div class="title">{{video.name}}</div>
					</div>
				</div>
			</div>

			
			<div class="news-list">
				<div class="heading">
					<div class="heading-content">
						<div class="text"><span></span>&nbsp;&nbsp;&nbsp;NEWS&nbsp;&nbsp;&nbsp;<span></span></div>
						<div class="bg-left"></div>
						<div class="bg-right"></div>
					</div>
				</div>
				<div class="box">
					<div class="sub-heading">TOP NEWS FOR PANDORA</div>
					<div class="news-list-box-content">
						<div class="news" v-for="(news, index) in newsList" :key="index" v-on:click="openNewsPopup(news)">
							<div class="time">-- {{news.create_time}}</div>
							<div class="title">{{news.title}}</div>
						</div>
					</div>
				</div>
				

				<div class="more"><router-link to="/news">MORE</router-link></div>
			</div>

			<div class="right-footer" v-on:click="openSharePopup">
				<div class="btn-share">
					<div class="box">SHARE</div>
				</div>
				<div class="btn-circle">
					<div class="point"><div class="point-content"><i class="fa fa-weibo"></i></div></div>
				</div>
				<div class="btn-circle">
					<div class="point"><div class="point-content"><i class="fa fa-wechat"></i></div></div>
				</div>
			</div>

			
		</div>

		<div class="bg-wrapper">
			<div class="bg-1"></div>
			<div class="bg-2"></div>
			<div class="bg-3"></div>
			<img src="/web-static/img/home-bg-1.png" style="visibility: hidden;">
			<img src="/web-static/img/home-bg-2.png" style="visibility: hidden;">
			<img src="/web-static/img/home-bg-3.png" style="visibility: hidden;">
		</div>

		<div class="beian-info">
			<a href="http://beian.miit.gov.cn/" target="blank">闽ICP备17028426号-1</a> <span>/</span> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35021302000309" target="blank">公网安备35021302000309</a>
		</div>

		<popup v-bind:html="videoPopupHtml" v-bind:show="videoPopupShow" v-on:before-close="videoPopupBeforeClose"></popup>
		<popup v-bind:html="newsPopupHtml" v-bind:show="newsPopupShow" v-on:before-close="newsPopupBeforeClose"></popup>
		<popup v-bind:html="sharePopupHtml" v-bind:show="sharePopupShow" v-on:before-close="sharePopupBeforeClose"></popup>
		
	</div>
</template>

<script>
import $ from 'jquery'
import NewsGenerator from '@/components/NewsGenerator'
export default {
	beforeCreate: function() {

		setTimeout(function() {
			$('#app').css({height: '100%'});
		})
		
	},
	created: function() {

		if (!this.videos.length) {
			this.axios.get('/video/getList').then((response) => {
				this.videos = response.data
				this.video = this.videos[0]
				global.videos = response.data
			})
		} else {
			this.video = this.videos[0]
		}
		
		if (!this.newsList.length) {
			this.axios.get('/news/getList').then((response) => {
				this.newsList = response.data
				global.newsList = response.data
			})
		}
	},
	mounted: function() {

		var bg1 = new Image();
		bg1.src = '/web-static/img/home-bg-1.png';
		bg1.onload = function() {
			$('#app .bg-1').css({opacity: 1});
		}

		$('#app .menu a').eq(0).addClass('router-link-active');
		
		setTimeout(function() {
			$('#app .page-home').addClass('init');
		}, 0)
		setTimeout(function() {
			$('#app .menu').css({
				overflow: 'visible'
			});
		}, 2200)

		
		setTimeout(function() {
			var video = document.getElementById('video-small');
			video.volume = 0;
			video.play()
		},3000)
		
	},
	destroyed: function() {
		$('#app').css({height: 'auto'});
	},
	data: function() {

		return {
			videoPopupShow: false,
			videoPopupHtml: '',
			newsPopupShow: false,
			newsPopupHtml: '',
			newsPopupInterval: null,
			newsPopupCurrentNewsId: null,
			sharePopupShow: false,
			sharePopupHtml: `
				<div class="popup-share">
					<div class="weibo">
						<p>
							- 新浪微博 -
							<img src="/web-static/img/weibo-qrcode.png">
						</p>
					</div><div class="weixin">
						<p>
							- 微信 -
							<img src="/web-static/img/weixin-qrcode.jpg">
						</p>
					</div>

				</div>
			`,
			menuItems: global.menuItems || [],
			videos: global.videos || [],
			video: {},
			newsList: global.newsList || []
		}
	},
	methods: {
		switchVideo: function(index, event) {

			if (!this.videos[index]) {
				return;
			}
			if (!this.videos[index].url) {
				return
			}
			this.video = this.videos[index]

			setTimeout(function() {
				document.getElementById('video-small').play()
			}, 1000)

			$('.visual.active').removeClass('active');
			
			$('.visual').eq(index).addClass('active');
		},
		openVideoPopup: function() {

			var html = `
				<video class="popup-video" id="popup-video" src="${this.video.url}" autoplay controls></video>`;
			this.videoPopupHtml = html
			this.videoPopupShow = true		
		},
		openNewsPopup: function(news) {

			this.newsPopupCurrentNewsId = news.id
			this.newsPopupHtml = ''
			this.newsPopupShow = true

			if (!news.content) {
				let fakeNews = {
					title: news.title,
					content: 'Loading...',
					create_time: news.create_time,
				}
				clearInterval(this.newsPopupInterval)
				this.newsPopupInterval = setInterval(() => {
					fakeNews.content += '.'
					this.newsPopupHtml = NewsGenerator(fakeNews)
				}, 500)
				this.axios.get(`/news/getData`, {
					params: {
						'id': news.id
					},
				}).then((response) => {
					news = response.data
					this.newsList.forEach(i => {
						if (i.id === news.id) {
							i.content = news.content
						}
					})
					global.newsList = this.newsList
					if (this.newsPopupCurrentNewsId === news.id) {
						var html = NewsGenerator(news);
						this.newsPopupHtml = html
						clearInterval(this.newsPopupInterval)
					}
				})
			} else {
				var html = NewsGenerator(news);
				this.newsPopupHtml = html
			}
		},
		openSharePopup: function() {

			this.sharePopupShow = true
		},
		videoPopupBeforeClose: function() {
			
			var video = document.getElementById('popup-video');
			video.pause();
			this.videoPopupShow = false;
		},
		newsPopupBeforeClose: function() {
			
			clearInterval(this.newsPopupInterval)
			this.newsPopupShow = false;
		},
		sharePopupBeforeClose: function() {
			
			this.sharePopupShow = false;
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/Home.vue